import { memo, useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button, Dropdown, Tooltip } from '@aimsos/ui';

import { ChevronDown, NotebookPen, Phone, Send, Users } from 'lucide-react';

/**
 * History's actions, the same on both subtabs (CT-5724): New note, Log call,
 * Log meeting, and Draft (Email, SMS). It replaces the single "Actions" menu of
 * CT-5527.
 *
 * New note is the primary action and Draft a secondary menu, as in the
 * prototype. Draft goes to the Concierge (CT-5721); while the shell cannot open
 * it, Draft is disabled with a tooltip saying why — never a flow that does nothing.
 */
const HistoryToolbar = memo(function HistoryToolbar({ canDraft, onNewNote, onLogCall, onLogMeeting, onDraft }) {
  const { t } = useTranslation('unified-profiles');

  const draftEmail = useCallback(() => onDraft('email'), [onDraft]);
  const draftSms = useCallback(() => onDraft('sms'), [onDraft]);

  return (
    <div data-testid="history-toolbar" className="flex shrink-0 flex-wrap items-center gap-2">
      <Button variant="primary" size="sm" leftIcon={NotebookPen} onClick={onNewNote}>
        {t('history.toolbar.newNote')}
      </Button>
      <Button variant="secondary" size="sm" leftIcon={Phone} onClick={onLogCall}>
        {t('history.toolbar.logCall')}
      </Button>
      <Button variant="secondary" size="sm" leftIcon={Users} onClick={onLogMeeting}>
        {t('history.toolbar.logMeeting')}
      </Button>
      {canDraft ? (
        <Dropdown
          align="right"
          trigger={
            <Button variant="secondary" size="sm" leftIcon={Send} rightIcon={ChevronDown}>
              {t('history.toolbar.draft')}
            </Button>
          }
        >
          <Dropdown.Item onClick={draftEmail}>{t('history.toolbar.draftEmail')}</Dropdown.Item>
          <Dropdown.Item onClick={draftSms}>{t('history.toolbar.draftSms')}</Dropdown.Item>
        </Dropdown>
      ) : (
        <Tooltip content={t('history.toolbar.draftUnavailable')} size="compact">
          <Button variant="secondary" size="sm" leftIcon={Send} rightIcon={ChevronDown} disabled>
            {t('history.toolbar.draft')}
          </Button>
        </Tooltip>
      )}
    </div>
  );
});

export default HistoryToolbar;
